<div class="p-2">
  <div class="row">
    <div class="col-12 mb-3">
      <label class="form-label" for="direction" translate>app.deal.direction</label>
      <div class="input-group input-group-sm">
        <select class="form-select form-select-sm" id="direction"
                [(ngModel)]="cur.direction"
                [disabled]="apiService.getParam('$action') == 'edit-deal'">
          <option value="LONG" translate>app.deal.long-direction</option>
          <option value="SHORT" translate>app.deal.short-direction</option>
        </select>
        <input type="date" class="form-control form-control-sm"
               [ngModelOptions]="{standalone: true}"
               (ngModelChange)="cur.created = $event"
               [ngModel]="this.cur.created | date:'yyyy-MM-dd'"
               [disabled]="apiService.getParam('$action') == 'edit-deal'"/>
      </div>
    </div>

    <div class="col-12 mb-3">
      <label class="form-label" for="account" translate>app.deal.account</label>
      <select class="form-select form-select-sm" id="account"
              [(ngModel)]="cur.account">
        <option *ngFor="let account of accountService.getAccounts()"
                [value]="account.id">{{ account.name }}
        </option>
      </select>
      <div *ngIf="submitted && isEmpty(cur.account)" class="text-danger" translate>app.deal.account.empty.error</div>
    </div>

    <div class="col-12 mb-3">
      <label class="form-label" for="folder" translate>app.deal.folder</label>
      <select class="form-select form-select-sm" id="folder"
              [(ngModel)]="cur.folder">
        <option *ngFor="let folder of folderService.getFolders()"
                [ngClass]="{ 'd-none': folder.system }"
                [value]="folder.id">{{ folder.name }}
        </option>
      </select>
    </div>

    <div class="col-12 mb-3">
      <div>
        <label class="form-label" for="account"
               translate>app.deal.pair</label>&nbsp;<a class="link-primary cursor-pointer" data-bs-toggle="modal"
                                                       *ngIf="apiService.getParam('$action') == 'add-deal'"
                                                       data-bs-target="#importToken" translate>app.token.import</a>
      </div>
      <div class="input-group input-group-sm dropdown">
        <input type="text" id="fromToken" autocomplete="off"
               placeholder="{{'app.deal.from-token.example' | translate}}"
               class="form-control form-control-sm dropdown-toggle"
               data-bs-toggle="dropdown"
               [(ngModel)]="cur.fromToken"
               [ngClass]="{ 'invalid': submitted && isEmpty(cur.fromToken) }"
               [readOnly]="apiService.getParam('$action') == 'edit-deal'"
               [disabled]="apiService.getParam('$action') == 'edit-deal'"
               (keyup)="findToken(cur.fromToken)"/>
        <ul class="dropdown-menu">
          <li *ngFor="let token of cur.tokens" [value]="token.id">
            <a class="dropdown-item" (click)="cur.fromAddress = token.address; cur.fromToken = token.name">
              {{ token.name }}<br/>
              <small class="text-muted">{{ token.address }}</small>
            </a>
          </li>
          <li *ngIf="cur.tokens.length === 0">
            <a class="dropdown-item" (click)="$event.stopPropagation()">Nothing found...</a>
          </li>
        </ul>
        <span class="input-group-text">/</span>
        <input type="text" id="toToken" autocomplete="off"
               placeholder="{{'app.deal.to-token.example' | translate}}"
               class="form-control form-control-sm dropdown-toggle"
               data-bs-toggle="dropdown"
               [(ngModel)]="cur.toToken"
               [ngClass]="{ 'invalid': submitted && isEmpty(cur.toToken) }"
               [readOnly]="apiService.getParam('$action') == 'edit-deal'"
               [disabled]="apiService.getParam('$action') == 'edit-deal'"
               (keyup)="findToken(cur.toToken)"/>
        <ul class="dropdown-menu">
          <li *ngFor="let token of cur.tokens" [value]="token.id">
            <a class="dropdown-item" (click)="cur.toAddress = token.address; cur.toToken = token.name">
              {{ token.name }}<br/>
              <small class="text-muted">{{ token.address }}</small>
            </a>
          </li>
          <li *ngIf="cur.tokens.length === 0">
            <a class="dropdown-item" (click)="$event.stopPropagation()">Nothing found...</a>
          </li>
        </ul>
      </div>
      <div *ngIf="submitted && isEmpty(cur.fromAddress)" class="text-danger" translate>app.deal.from-token.empty.error
      </div>
      <div *ngIf="submitted && isEmpty(cur.toAddress)" class="text-danger" translate>app.deal.to-token.empty.error</div>
    </div>

    <div class="col-12 mb-3">
      <label class="form-label" for="quantity" translate>app.deal.quantity</label>
      <input type="text" id="quantity" autocomplete="off"
             placeholder="{{'app.deal.quantity' | translate}}"
             class="form-control form-control-sm"
             [(ngModel)]="cur.quantity"
             [ngClass]="{ 'invalid': submitted && cur.quantity <= 0 }"/>

      <div *ngIf="submitted && cur.quantity <= 0" class="text-danger" translate>app.deal.quantity.empty.error</div>
    </div>

    <div class="col-12 mb-3">
      <label class="form-label" for="price" translate>app.deal.price</label>
      <div class="input-group input-group-sm">
        <span class="input-group-text">$</span>
        <input type="text" id="price" autocomplete="off" class="form-control"
               placeholder="{{'app.deal.price' | translate}}"
               [(ngModel)]="cur.price"
               (change)="calcSum()"
               [ngClass]="{ 'invalid': submitted && cur.price <= 0 }"/>
        <span class="input-group-text">=</span>
        <input type="text" id="sum" autocomplete="off"
               placeholder="{{'app.deal.sum' | translate}}"
               class="form-control"
               [(ngModel)]="cur.sum"
               (change)="calcPrice()"/>
      </div>
      <div class="form-text" *ngIf="deal ? deal.last_price > 0 : false">Current price: ${{ deal.last_price }}</div>

      <div *ngIf="submitted && cur.price <= 0" class="text-danger" translate>app.deal.price.empty.error</div>
    </div>

    <div class="col-12">
      <div class="row">
        <div class="col-12 mb-3">
          <a data-bs-toggle="collapse"
             href="#moreInfo" role="button" aria-expanded="false"
             aria-controls="collapseExample">More info</a>
        </div>

        <div id="moreInfo" class="collapse">
          <div class="col-12 mb-3">
            <label class="form-label" for="tags" translate>app.deal.tags</label>
            <input type="text" id="tags" autocomplete="off"
                   placeholder="{{'app.deal.tags' | translate}}"
                   class="form-control form-control-sm"
                   [(ngModel)]="cur.tags"/>
            <div *ngIf="cur.tags.split(' ').length > 10" class="text-danger"
                 translate>app.deal.tags.too-many
            </div>
          </div>

          <div class="col-12 mb-3">
            <label class="form-label" for="comment" translate>app.deal.comment</label>
            <textarea type="text" id="comment" rows="3"
                      placeholder="{{'app.deal.comment' | translate}}"
                      class="form-control form-control-sm"
                      [(ngModel)]="cur.comment"></textarea>
            <div *ngIf="cur.comment.length > 255" class="text-danger">
              {{ ('app.deal.comment.too-long' | translate).replace('%s', cur.comment.length) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mb-3" *ngIf="apiService.getParam('$action') === 'add-deal'">
      <div (click)="cur.inOrder = !cur.inOrder" class="button">
        <span class="icon icon24" [ngClass]="cur.inOrder ? 'checked-checkbox' : 'unchecked-checkbox'"></span>
        Deal in order
      </div>
    </div>

    <div class="col-12 mb-3 text-danger" *ngIf="error">
      {{ error }}
    </div>

    <div class="col-12">
      <button type="button" class="btn btn-primary btn-sm me-2" [disabled]="loading" (click)="onSubmit()" translate>
        {{ apiService.getParam('$action') === 'add-deal'? 'app.deal.button.create' : 'app.deal.button.edit' }}
      </button>
      <button type="button" class="btn btn-info btn-sm me-2"
              (click)="attrDelete(deal, getAttribute(deal.attributes, dealService.inOrderAttrId).id)"
              *ngIf="mode === 'edit' && getAttributeValue(deal.attributes, dealService.inOrderAttrId, false)"
              [disabled]="loading" translate>
        app.deal.button.in-order
      </button>
      <button type="button" class="btn btn-info btn-sm me-2" (click)="outDeal.open(deal)"
              *ngIf="mode === 'edit' && !getAttributeValue(deal.attributes, dealService.inOrderAttrId, false)"
              [disabled]="loading" translate>
        app.deal.button.out-order
      </button>
      <button type="button" class="btn btn-danger btn-sm me-2"
              (click)="remove(apiService.getParam('$deal'))"
              *ngIf="apiService.getParam('$deal')" [disabled]="loading" translate>
        app.deal.button.remove
      </button>
    </div>
  </div>

  <modal #rd>
    <div class="vertical">
      <div class="horizontal" translate>Do you want to remove deal?</div>
      <label for="sellPrice1" translate>app.sell.price</label>
      <div class="horizontal">
        <input type="text" id="sellPrice1" autocomplete="off"
               [(ngModel)]="sell.sellPrice"
               placeholder="{{'app.sell.price' | translate}}"/>
      </div>
      <br/>

      <button class="blue" [disabled]="removeDeal ? removeDeal.loading : false" translate (click)="deleteDeal()">
        app.folder.button.yes
      </button>
      <button (click)="rd.close()" translate>app.folder.button.no</button>
    </div>
  </modal>

  <modal #ed>
    <div class="vertical">
      <div class="horizontal" translate>Price for sell part of deal?</div>
      <label for="sellPrice2" translate>app.sell.price</label>
      <div class="horizontal">
        <input type="text" id="sellPrice2" autocomplete="off"
               [(ngModel)]="sell.sellPrice"
               placeholder="{{'app.sell.price' | translate}}"/>
      </div>

      <br/>

      <button class="blue" [disabled]="editDeal ? editDeal.loading : false" translate (click)="applyDealChanges()">
        app.folder.button.yes
      </button>
      <button (click)="ed.close()" translate>app.folder.button.no</button>
    </div>
  </modal>

  <modal #od>
    <div class="p-2">
      <div class="row">
        <div class="col-12 mb-3">
          <h3>Create out order</h3>
        </div>
        <div class="col-12 mb-3">
          <label class="form-label" for="sellQuantity" translate>app.sell.quantity</label>
          <input type="text" id="sellQuantity" autocomplete="off"
                 [(ngModel)]="sell.sellQuantity"
                 class="form-control form-control-sm" placeholder="{{'app.sell.quantity' | translate}}"/>
          <div class="form-text cursor-pointer" (click)="balance()">Balance: {{ deal? deal.quantity : 0 }}</div>
        </div>
        <div class="col-12 mb-3">
          <label class="form-label" for="sellPrice3" translate>app.sell.price</label>
          <input type="text" id="sellPrice3" autocomplete="off"
                 [(ngModel)]="sell.sellPrice"
                 class="form-control form-control-sm" placeholder="{{'app.sell.price' | translate}}"/>
        </div>
        <div class="col-12 mb-3">
          <label class="form-label" for="orderType" translate>app.order.type</label>
          <select class="form-select form-select-sm" id="orderType" [(ngModel)]="sell.orderType">
            <option [value]="'TAKE_PROFIT'" translate>app.order.take-profit</option>
            <option [value]="'STOP_LOSS'" translate>app.order.stop-loss</option>
          </select>
        </div>
        <div class="col-12">
          <button class="btn btn-sm btn-primary" [disabled]="editDeal ? editDeal.loading : false"
                  (click)="applyOutDeal()" translate>
            app.folder.button.yes
          </button>
          <button class="btn btn-sm btn-white" (click)="od.close()" translate>app.folder.button.no</button>
        </div>
      </div>
    </div>
  </modal>

  <div class="modal fade" id="importToken" data-bs-backdrop="static"
       data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" translate>app.token.import.title</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label" for="tokenDefinition" translate>app.token.definition</label>
              <select class="form-control form-control-sm" id="tokenDefinition"
                      [(ngModel)]="import.definition">
                <optgroup label="Networks">
                  <option *ngFor="let network of networkService.getNetworks()"
                          [value]="'n' + network.id">{{ network.name | translate }}
                  </option>
                </optgroup>
                <optgroup label="Exchanges">
                  <option *ngFor="let exchange of exchangeService.getExchanges()"
                          [value]="'e' + exchange.id">{{ exchange.name | translate }}
                  </option>
                </optgroup>
              </select>
              <p class="text-muted">
                If you select network item: make sure that you are using contract address.<br/>
                If you select exchange item: make sure that you are using token symbol.
              </p>
            </div>
            <div class="col-12 mb-3">
              <label class="form-label" for="tokenAddress" translate>app.token.address</label>
              <input type="text" id="tokenAddress" autocomplete="off"
                     class="form-control form-control-sm"
                     placeholder="{{'app.token.address.example' | translate}}"
                     [(ngModel)]="import.address"/>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary"
                  data-bs-dismiss="modal" translate>app.token.button.cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary"
                  (click)="importToken($event)" translate>app.token.button.import
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
